// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import intl from 'react-intl-universal'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_COLLECTIONS, setCollections } from '../websked'

export default (action$, store) =>
  action$.ofType(ACTION_WEBSKED_COLLECTIONS).mergeMap((action) => {
    const url = `/websked/collections/api/v1/usage/${action.payload}`
    return Observable.fromPromise(fetch(url, { credentials: 'same-origin' }))
      .mergeMap((response) => {
        if (!response.ok) {
          throw new Error(
            intl.get('epics.webskedCollectionsEpic.errors.fetchFailure')
          )
        }
        return response.json()
      })
      .map((collections) => {
        return setCollections(collections)
      })
      .catch((error) => Observable.of(errorAction(error)))
  })
